import { AxiosResponse } from "axios";
import dayjs from "dayjs";

export function adaptFileResponse(
    res: AxiosResponse<Blob, any>
): { blob: Blob; filename: string } {
    const contentType = res.headers?.["content-type"] ?? "";
    const contentDisposition = res.headers?.["content-disposition"] ?? "";

    let filenameMatch =
        contentDisposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/) ||
        contentDisposition.match(/filename=["']?([^"']+)["']?/);

    const filename =
        filenameMatch?.[1]
            ?.trim()
            ?.replace(/%20/g, " ")
            ?.replace(/\+/g, " ") || generateDateFileName(contentType);

    return { blob: res.data, filename };
}

function generateDateFileName(contentType: string): string {
    let ext = ".xlsx";

    if (contentType.includes("pdf")) {
        ext = ".pdf";

    }
    else if (contentType.includes("zip")) {
        ext = ".zip";
    }

    const date = dayjs().format("YYYY-MM-DD");
    
    return `lnow_${date}${ext}`;
}
